import React, { FC, useCallback } from 'react';
import { ChapterNumberContainer } from './Atoms';
import { useFullBook } from 'src/modules/shared';
import { AugmentationButton, ChapterNumber } from 'src/modules/shared/components';
import { SpriteIconsLight } from 'src/config/api/models/FontAwesome';
import { useSnackbar } from 'notistack';
import { IBookChapter } from 'src/config/api/models/Chapter';
import {
  TrajectorySectionCode,
  trajectorySectionLabelLookup,
} from 'src/config/api/models/Trajectory';

type Props = {
  trajectoryNumber: string;
  trajectoryTitle: string;
  sectionCode: TrajectorySectionCode;
};

const TrajectoryViewDetailInfo: FC<Props> = ({
  trajectoryNumber,
  trajectoryTitle,
  sectionCode,
}) => {
  const fullBook = useFullBook();
  const { enqueueSnackbar } = useSnackbar();

  const handleCopyUrl = useCallback(() => {
    navigator.clipboard.writeText(window.location.href);
    enqueueSnackbar('gekopieerde traject url', {
      variant: 'success',
      autoHideDuration: 2000,
    });
  }, [enqueueSnackbar]);

  const handleCopyPath = useCallback(() => {
    if (fullBook.data) {
      let breadcrumb = fullBook.data.title;
      let chaptersList: IBookChapter[] = [...(fullBook.data?.chapters || [])];
      let index = trajectoryNumber?.split('.').slice(0, -1);
      if (index !== undefined && index.length > 0 && chaptersList.length > 0) {
        let currentChapter = chaptersList[Number(index[0]) - 1];
        breadcrumb += ` > ${currentChapter.number} - ${currentChapter.title}`;
        for (let i = 1; i < index?.length; i++) {
          currentChapter = currentChapter.childrenChapters[Number(index[i]) - 1];
          breadcrumb += ` > ${currentChapter.number} - ${currentChapter.title}`;
        }
      }
      breadcrumb += ` > ${trajectoryNumber} - ${trajectoryTitle}`;
      breadcrumb += ` > ${trajectorySectionLabelLookup[sectionCode as TrajectorySectionCode]}`;
      navigator.clipboard.writeText(breadcrumb);
      enqueueSnackbar('trajectpad gekopieerd', {
        variant: 'success',
        autoHideDuration: 2000,
      });
    }
  }, [fullBook.data, sectionCode, enqueueSnackbar, trajectoryNumber, trajectoryTitle]);

  return (
    <ChapterNumberContainer>
      <ChapterNumber>{trajectoryNumber}</ChapterNumber>
      <AugmentationButton
        className="clipboard-trajectory-button"
        icon={SpriteIconsLight.LOCATION_DOT}
        tooltip={'Kopieer pad'}
        onButtonClick={handleCopyPath}
        btSize="md"
      />
      <AugmentationButton
        className="clipboard-trajectory-button"
        tooltip={'Kopieer link'}
        icon={SpriteIconsLight.LINK}
        onButtonClick={handleCopyUrl}
        btSize="md"
      />
    </ChapterNumberContainer>
  );
};

export default TrajectoryViewDetailInfo;
